import { Button } from "@/shared/components/ui/button"




export default function RipsCtaSection() {
  return (
    <section className="flex flex-col justify-center items-center py-24 bg-white text-center px-4">
       <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12">
        La Mejor Opción para <span className="text-[#06A1FF]">Profesionales Independientes </span> que no requieran facturación
      </h1>
      <div className="max-w-7xl w-full mx-auto bg-gradient-to-r from-sky-50 to-white rounded-3xl shadow-xl border border-gray-100 flex flex-col md:flex-row items-center gap-10 p-10">
        {/* Imagen o ilustración */}
        <div className="flex-1">
          <img
            src="/images/enviarrips.png" 
            alt="Gestión de RIPS"
            className="rounded-2xl shadow-lg border border-gray-100"
          />
          
        </div>

        {/* Texto */}
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Gestión de RIPS sin facturación
          </h2>
          <p className="text-gray-600 mb-8 text-lg leading-relaxed">
            Simplifica el envío y control de tus archivos RIPS sin necesidad de emitir facturas.
Ideal para profesionales que solo reportan servicios al sistema de salud, manteniendo trazabilidad, validación y control de la información.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <a href="https://app.rapyfact.com/register" target="_blank" rel="noopener noreferrer">
            <Button size="lg" className="[#06A1FF] hover:bg-sky-700 text-white">
              Empezar ahora
            </Button>
            </a>
            <Button
              size="lg"
              variant="outline"
              className="border-[#06A1FF] text-[#06A1FF] hover:bg-sky-50"
               onClick={() => {
    window.open(
      "https://wa.me/573135909091?text=Soy%20profesional%20independiente%20y%20requiero%20RIPS%20sin%20facturación",
      "_blank"
    )
  }}
            >
              Solicitar cotización
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
